import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'
import { TreeControlPanelDto, TreeControlPanelClickDto } from '../components/protected/central-control/public-panel/types/tree-maps'
import { TDataTableParameters } from '../components/protected/central-control/public-panel/types/data-table-parameters'

@Injectable()
export class CentralControlService {
	private readonly basePath = `${PATH}/central-control/public-panel`

	constructor(
		private http: HttpClient
	) { }


	private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append('x-source-from', 'PAINEL')
	}

	public getMapPins(companyId: string): Observable<Array<TreeControlPanelDto>> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${this.basePath}/maps/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public updatePinLocation(treeId: string, location: { lat: number, lng: number }): Observable<void> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.patch<void>(`${this.basePath}/maps/pin`, {
				idMongo: treeId,
				lat: location.lat,
				lng: location.lng
			}, {
				headers: options
			})
	}

	public updateMapCacheInPublicPanel(): Observable<void> {
		const options: HttpHeaders = this.setHeader()
		const companyId = localStorage.getItem('companyId')

		return this.http
			.post<void>(`${this.basePath}/publish/${companyId}`, {
				headers: options
			})
	}

	public getPublicTreePanelInformation(treeId: string): Observable<TreeControlPanelClickDto> {
		const options: HttpHeaders = this.setHeader()
		const companyId = localStorage.getItem('companyId')

		return this.http
			.get<any>(`${this.basePath}/info/${companyId}?treeId=${treeId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public updateTreePublicPanel(treeIds: Array<string>, action: 'enable' | 'disable'): Observable<void> {
		const options: HttpHeaders = this.setHeader()
		const companyId = localStorage.getItem('companyId')

		return this.http
			.patch<void>(`${this.basePath}/publish/${companyId}`, { ids: treeIds, action }, {
				headers: options
			})
	}

	public updateMapCache(companyId: string): Observable<Array<TreeControlPanelDto>> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.patch<any>(`${this.basePath}/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public listTreesPublicPanel(
		dataTablesParameters: TDataTableParameters,
		filterText: string,
		dateStart: string,
		dateEnd: string,
		searchTruncatedStringFormated: string
	) {
		const options: HttpHeaders = this.setHeader()
		const companyId = localStorage.getItem('companyId')

		return this.http.get(
			`${this.basePath}/${companyId}?skip=${dataTablesParameters.start}` +
			`&limit=${dataTablesParameters.length}` +
			`&order=${dataTablesParameters.columns[dataTablesParameters.order[0].column].data}` +
			`&typeOrder=${dataTablesParameters.order[0].dir}` +
			`&search=${filterText}` +
			`&dateStart=${dateStart}` +
			`&dateEnd=${dateEnd}${searchTruncatedStringFormated}`,
			{
				headers: options
			}
		)
	}
}
